const Resources = {

    table_headers: [
        { 
          text:  'Name',  
          align: 'start', 
          value: 'name',
        },
        { 
            text: 'Associates',           
            value: 'total_associates' 
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Associates',
            href:   '/associates',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Roles',
            href:   '/associate-roles',
            arrow:  " ",
        },
    ],

    deletion_validation_table_headers: [
        { 
          text:     'Role',
          align:    'start',
          value:    'name',
        },
        {
            text:   '# of associates',
            value:  'associated_models_count',
        },
    ],

    helps: [
        {
            label: '¿How to add a Role?', 
            instruction: `https://scribehow.com/embed/How_to_Add_a_Role__B-p60cKxTcOMESQgtqq5Sg?as=scrollable`
        },
        {
            label: '¿How to delete a Role?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Roles__92i54xh_S1qol9_JC-VaJg?as=scrollable`
        },
    ],
}

export default Resources;